// extracted by mini-css-extract-plugin
export default {"profileItem":"worfkorce_member-module___profileItem___b9b26dbb"};